module.exports = "<h1 class=\"ui-title margin-lg\">\r\n  <a ui-sref=\"^()\">\r\n    <i class=\"fa fa-angle-left\"></i>\r\n  </a>\r\n  Notaría\r\n</h1>\r\n<tiles gap=\"sm\">\r\n  <tile>\r\n    <app-launcher color=\"#0091EA\">\r\n      <icon>Bu</icon>\r\n      <label>Buscador</label>\r\n    </app-launcher>\r\n  </tile>\r\n  <tile>\r\n    <app-launcher color=\"#0091EA\">\r\n      <icon>Pl</icon>\r\n      <label>Plantillas</label>\r\n    </app-launcher>\r\n  </tile>\r\n</tiles>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/fanconsultores/components/fanconsultores/admin/dashboard/notaria/template.html
// module id = 2739
// module chunks = 0